export const ColorsStorage = {
  color: {
    fill: [
      "rgba(181, 67, 82, 0.8)",
      "rgba(221, 79, 53, 0.8)",
      "rgba(162, 91, 42, 0.8)",
      "rgba(226, 147, 51, 0.8)",
      "rgba(189, 158, 77, 0.8)",
      "rgba(191, 197, 70, 0.8)",
      "rgba(84, 130, 49, 0.8)",
      "rgba(110, 207, 75, 0.8)",
      "rgba(94, 202, 152, 0.8)",
      "rgba(93, 119, 202, 0.8)",
      "rgba(105, 69, 200, 0.8)",
      "rgba(202, 129, 208, 0.8)",
      "rgba(201, 72, 206, 0.8)",
      "rgba(125, 52, 125, 0.8)",
      "rgba(218, 77, 142, 0.8)",
      "rgba(74, 135, 96, 0.8)",
      "rgba(247, 235, 112, 0.8)",
      "rgba(154, 201, 222, 0.8)",
      "rgba(243, 111, 38, 0.8)",
      "rgba(35, 113, 171, 0.8)",
      "rgba(181, 178, 212, 0.8)",
      "rgba(247, 199, 221, 0.8)",
      "rgba(198, 227, 191, 0.8)",
      "rgba(245, 141, 144, 0.8)",
    ],
    border: [
      "#B54352",
      "#DD4F35",
      "#A25B2A",
      "#E29333",
      "#BD9E4D",
      "#BFC546",
      "#548231",
      "#6ECF4B",
      "#5ECA98",
      "#5D77CA",
      "#6945C8",
      "#CA81D0",
      "#C948CE",
      "#7D347D",
      "#DA4D8E",
      "#4A8760",
      "#f7eb70",
      "#9ac9de",
      "#f36f26",
      "#2371ab",
      "#b5b2d4",
      "#f8c7dd",
      "#c6e3bf",
      "#f58d90",
    ],
    brand: [
      "rgba(56, 5, 160, 0.6)",
      "rgba(131, 10, 184, 0.6)",
      "rgba(205, 20, 196, 0.6)",
      "rgba(221, 34, 156, 0.6)",
      "rgba(233, 55, 130, 0.6)",
      "rgba(242, 83, 124, 0.6)",
      "rgba(249, 119, 137, 0.6)",
      "rgba(253, 160, 166, 0.6)",
      "rgba(254, 181, 184, 0.6)",
    ],
    brand_border: [
      "#3805A0",
      "#830AB8",
      "#CD14C4",
      "#DD229C",
      "#E93782",
      "#F2537B",
      "#F97788",
      "#FDA0A6",
      "#FEB5B7",
    ],
  },
  secondary_color: {
    fill: [
      "rgba(181, 67, 82, 0.8)",
      "rgba(221, 79, 53, 0.8)",
      "rgba(162, 91, 42, 0.8)",
      "rgba(226, 147, 51, 0.8)",
      "rgba(189, 158, 77, 0.8)",
      "rgba(191, 197, 70, 0.8)",
      "rgba(84, 130, 49, 0.8)",
      "rgba(110, 207, 75, 0.8)",
      "rgba(94, 202, 152, 0.8)",
      "rgba(93, 119, 202, 0.8)",
      "rgba(105, 69, 200, 0.8)",
      "rgba(202, 129, 208, 0.8)",
      "rgba(201, 72, 206, 0.8)",
      "rgba(125, 52, 125, 0.8)",
      "rgba(218, 77, 142, 0.8)",
      "rgba(74, 135, 96, 0.8)",
    ],
    border: [
      "#B54352",
      "#DD4F35",
      "#A25B2A",
      "#E29333",
      "#BD9E4D",
      "#BFC546",
      "#548231",
      "#6ECF4B",
      "#5ECA98",
      "#5D77CA",
      "#6945C8",
      "#CA81D0",
      "#C948CE",
      "#7D347D",
      "#DA4D8E",
      "#4A8760",
    ],
    brand: [
      "rgba(67, 147, 254, 0.8)",
      "rgba(125, 122, 225, 0.8)",
      "rgba(170, 104, 203, 0.8)",
      "rgba(221, 82, 177, 0.8)",
      "rgba(244, 250, 17, 0.7)",
      "rgba(247, 77, 156, 0.8)",
      "rgba(250, 102, 119, 0.8)",
      "rgba(250, 124, 83, 0.8)",
      "rgba(250, 145, 52, 0.8)",
      "rgba(250, 199, 25, 0.8)",
    ],
    brand_border: [
      "#4393FE",
      "#7D7AE1",
      "#AA68CB",
      "#DD52B1",
      "#F4FA11",
      "#F74D9C",
      "#FA6677",
      "#FA7C53",
      "#FA9F34",
      "#FAC719",
    ],
  },
};
